"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementParser = void 0;
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
const errors_1 = require("./errors");
const expressionParser_1 = require("./expressionParser");
const functionParser_1 = require("./functionParser");
const iterationStatementParser_1 = require("./iterationStatementParser");
class StatementParser extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    defaultResult() {
        return {
            type: 'EmptyStatement'
        };
    }
    wrapAsExpressionStatement(e) {
        return {
            type: 'ExpressionStatement',
            expression: e,
            loc: e.loc
        };
    }
    visitChildren(node) {
        const statements = [];
        for (let i = 0; i < node.childCount; i++) {
            statements.push(node.getChild(i).accept(this));
        }
        return {
            type: 'BlockStatement',
            body: statements
        };
    }
    visitErrorNode(node) {
        throw new errors_1.FatalSyntaxError({
            start: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine
            },
            end: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine + 1
            }
        }, `invalid syntax ${node.text}`);
    }
    visitStatement(ctx) {
        const exp = ctx.expressionStatement();
        const iter = ctx.iterationStatement();
        const func = ctx.functionDeclaration();
        const returnStatement = ctx.returnStatement();
        const conditionalStatement = ctx.conditionalStatement();
        if (exp != undefined) {
            return this.visitExpression(exp);
        }
        else if (iter != undefined) {
            return this.visitIterative(iter);
        }
        else if (func != undefined) {
            return this.visitFunctionDeclaration(func);
        }
        else if (returnStatement != undefined) {
            return this.visitReturnStatement(returnStatement);
        }
        else if (conditionalStatement != undefined) {
            return this.visitConditionalStatement(conditionalStatement);
        }
        return this.defaultResult();
    }
    visitExpression(ctx) {
        return this.wrapAsExpressionStatement(new expressionParser_1.default().visit(ctx));
    }
    visitIterative(ctx) {
        return new iterationStatementParser_1.IterationStatementParser().visit(ctx);
    }
    visitFunctionDeclaration(ctx) {
        return new functionParser_1.FunctionParser().visit(ctx);
    }
    visitConditionalStatement(ctx) {
        let alternate = undefined;
        const alternateStatementBlock = ctx._alternateStatementBlock;
        const elseIfStatement = ctx._elseIfStatement;
        if (alternateStatementBlock != undefined) {
            alternate = alternateStatementBlock;
        }
        else if (elseIfStatement != undefined) {
            alternate = elseIfStatement;
        }
        return {
            type: 'IfStatement',
            test: new expressionParser_1.default().visit(ctx._test),
            alternate: alternate == undefined ? this.defaultResult() : this.visit(alternate),
            consequent: this.visit(ctx._consequentStatement)
        };
    }
    visitReturnStatement(ctx) {
        let argument = undefined;
        if (ctx._argument != undefined) {
            argument = new expressionParser_1.default().visit(ctx._argument);
        }
        return {
            type: 'ReturnStatement',
            argument: argument
        };
    }
}
exports.StatementParser = StatementParser;
//# sourceMappingURL=statementParser.js.map